export default "__VITE_ASSET__JlYEijS1__"